import { Toolbar } from '@components/App/Toolbar'
import { AIChatButton } from '@components/ArtBoard/AIChat/components/AIChatButton/AIChatButton'
import type React from 'react'

import { useArtboardMode } from '@/hooks'
import { History, ProjectInfoMenu, ZoomMenu } from './components'
import { ArtboardTabs } from './components/ArtboardTabs'
import css from './Footer.module.scss'

interface Props {
  isReadOnly: boolean
  isEmbed: boolean
  hideTabs: boolean
}

export const Footer: React.FC<Props> = ({ isReadOnly, hideTabs, isEmbed }) => {
  const { seoMode } = useArtboardMode()

  if (isEmbed) {
    return null
  }

  const showTabs = !seoMode && !hideTabs

  return (
    <div className={css.container}>
      <Toolbar extraClassName={css.toolbar}>
        {!isReadOnly && <AIChatButton />}
        <div className={css.buttons_wrap}>
          {showTabs && <ArtboardTabs />}
          {!isReadOnly && <History />}
        </div>
      </Toolbar>
      <Toolbar extraClassName={css.toolbar}>
        <ZoomMenu />
        <ProjectInfoMenu />
      </Toolbar>
    </div>
  )
}
